import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        width="22"
        height="23"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.40828 1.46051C4.26181 1.47629 4.11578 1.49247 3.97026 1.50887C2.42766 1.68275 1.18802 2.92225 1.02086 4.46559C1.0054 4.60833 0.990176 4.75156 0.975342 4.89523"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.40828 21.5297C4.26181 21.514 4.11578 21.4977 3.97026 21.4813C2.42766 21.3074 1.18802 20.068 1.02086 18.5247C1.0054 18.382 0.990176 18.2388 0.975342 18.0951"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M0.975571 12.8076C0.948573 11.9299 0.948573 11.0606 0.975571 10.1829"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.5918 1.47009C17.7382 1.48587 17.8843 1.50205 18.0297 1.51845C19.5723 1.69233 20.812 2.93183 20.9792 4.47517C20.9946 4.61793 21.0099 4.76114 21.0247 4.90481"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.5918 21.5393C17.7382 21.5236 17.8843 21.5074 18.0297 21.491C19.5723 21.3171 20.812 20.0776 20.9792 18.5343C20.9946 18.3916 21.0099 18.2482 21.0247 18.1046"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.0244 12.8172C21.0514 11.9395 21.0514 11.0702 21.0244 10.1924"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.3079 21.5244C11.4301 21.5514 10.5609 21.5514 9.68311 21.5244"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.3174 1.47563C11.4397 1.44863 10.5704 1.44863 9.69263 1.47563"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
) as React.FC;
